export default "__VITE_ASSET__BmRk9__Q__"